import { configureStore } from '@reduxjs/toolkit'
import { databaseViewApi} from './redux/databaseView';
import { authApi} from './redux/authApi';
import {userFormSlice} from './RenderForm'

import appStateReducer from './redux/appState'
export  const store = configureStore(
	{
	reducer: 
		{
		appState: appStateReducer,
		userForm: userFormSlice.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[databaseViewApi.reducerPath]: databaseViewApi.reducer
		},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(databaseViewApi.middleware).concat(authApi.middleware),
	})
